export default
/* glsl */
"\ngl_FragColor = linearToOutputTexel( gl_FragColor );\n";